import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, prjPatternId} = map.data

    if (! (prjPatternId && 'SA_MAP' === mapTypeCode)) {
        return null
    }

    const onClick = () => map.commands.aiAnalyseWorkload()

    return {
        key: 'ai-analyse-workload',
        label: 'AI估算工作量',
        onClick,
    }
}
